<template>

  <div class="">
    <b-overlay
      :show="show"
      spinner-variant="primary"
      spinner-large
      rounded="sm"
      style="height:100vh"
      variant="dark"
      id="loader"
    >

      <b-container fluid style="padding-top: 100px;text-align:left">
        <b-row>
          <b-col cols="12 headerF"><HeaderFixed/></b-col>
          <b-col cols="12 headerM"><HeaderMobile/></b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
              <b-breadcrumb style=" background-color: #e9ecef78;">
                  <b-breadcrumb-item href="#home">
                    <router-link to="/Assamese">
                        <b-icon icon="house-door" scale="1.25" shift-v="1.25" aria-hidden="true"></b-icon>
                        মূখ্যপৃষ্ঠা
                    </router-link>
                  </b-breadcrumb-item>

                 <b-breadcrumb-item href="#" active>নতুন বিদ্যুৎ সংযোগ</b-breadcrumb-item>
              </b-breadcrumb>
            </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <span class="title">নতুন সংযোগৰ বাবে আবেদন </span>
          </b-col>
        </b-row>
        <hr/>
        <div class="paddingLeft30px">
        <form>
          <br>
        <b-row>
          <b-col cols=12 sm="12" md="3" lg="3" style="padding-top: 7px;">
                <span style="font-weight:600" >জিলা <span class="text-danger">*</span></span>
          </b-col>
          <b-col cols=12 sm="12" md="4" lg="4">
            <select name="" id="selectDistrict" required style="margin:10px 10px;width:250px" @change="showSubdiv('selectDistrict')">
                <option selected disabled value="000">--Select--</option>
            </select>
          </b-col>
          <b-col cols=12 sm="12" md="4" lg="4" style="padding-top: 7px;">
                  <span style="font-weight:600" >
                    <a href="AS_EstimateServiceCost">
                     
                        সেৱা সংযোগ অনুমান কেলকুলেটৰ
                  
                    </a>
                    <img src='https://www.apdcl.org/website/assets/new.gif' />
                  </span>
            </b-col>
        </b-row>
        <b-row>
          <b-col cols=12 sm="12" md="3" lg="3" style="padding-top: 7px;">
                <span style="font-weight:600" >উপসংমণ্ডল <span class="text-danger">*</span></span>
          </b-col>
          <b-col cols=12 sm="12" md="4" lg="4">
            <select name="" id="selectSubDiv" required style="margin:10px 10px;width:250px">
                <option selected disabled value="000">--Select--</option>
            </select>
          </b-col>
        </b-row>
        <b-row>
          <b-col  cols="12" sm="12" md="2" lg="2" offset-md=3 offset-lg=3>
                <b-button @click = "redirectUrl()" block pill variant="primary" size="md" class="go"  >
                  <b-icon  icon="arrow-right-short" animation="" scale="1.8" >  </b-icon>
                </b-button>
          </b-col>
        </b-row>
      </form>
    </br>
</div>

<div class="paddingLeftRem">

                <h4>নতুন বিদ্যুৎ সংযোগৰ বাবে লাগতিয়াল নথিসমূহ</h4>
                <ol style="padding-left:2em;padding-top:1em;">
                  <li>
                  আৱেদনকাৰীৰ শেহতীয়া পাছপ’ৰ্ট আকাৰৰ ফটো (jpeg বা png ফৰ্মেটত)
                  </li>
                  <li>
                পৰিচয় পত্ৰ (ভোটাৰ পৰিচয় পত্ৰ /পাছ্‌প'ৰ্ট/ দ্ৰাইভিং লাইচেন্স /ৰেচন কাৰ্ড/ বিপিএল কাৰ্ড/ পেন কাৰ্ড / আধাৰ কাৰ্ড / স্থানীয় সক্ষম কৰ্তৃপক্ষৰ পৰা ফটো পৰিচয় প্ৰমাণপত্ৰ)
                </li>
                  <li>
                  আৱাসিক ঠিকনাৰ প্ৰমাণ (ড্ৰাইভিং লাইচেঞ্চ/ বেঙ্ক পাছবুক/ ৰেচন কাৰ্ড / আধাৰ কাৰ্ড / টেলিফোন বিল / বিপিএল কাৰ্ড / বিদ্যমান বিদ্যুৎ বিল/ পাছ্‌প’ৰ্ট/ স্থানীয় সক্ষম কৰ্তৃপক্ষৰ পৰা প্ৰমাণপত্ৰ)
                  </li>
                  <li>
                চৌহদৰ আইনী দখলৰ প্ৰমাণ (হোল্ডিং নং, লীজ চুক্তি, ভাড়া চুক্তি, বিক্ৰী দলিল)
                  </li>
                  <li>
                  যদি আবেদনকাৰী ভূমিৰ গৰাকী নহয়, তেনে ক্ষেত্ৰত ভূমিৰ গৰাকীৰ পৰা আবেদনকাৰীক সংযোগ দিয়াৰ ক্ষেত্ৰত কোনো আপত্তি নথকাৰ শপতনামা আৰু ক্ষতিপূৰণ বণ্ড (বৈকল্পিক)।
                  </li>
                  <li>
                  কৰ্তৃত্বপ্ৰাপ্ত বৈদ্যুতিক ঠিকাদাৰ / চুপাৰভাইজাৰৰ পৰা টেষ্ট ৰিপ’ৰ্ট।
                  </li>

                </ol>

              টোকা: আপলোড কৰা সকলো নথিপত্ৰৰ প্ৰতিলিপি আবেদনকাৰীৰ দ্বাৰা স্ব-প্ৰমাণিত হ'ব আৰু অনুজ্ঞাপত্ৰধাৰীৰ প্ৰয়োজন হ'লে পৰিদৰ্শনৰ সময়ত মূল প্ৰতিলিপিটো প্ৰস্তুত কৰিব লাগিব পাৰে।
              </div>
              <br><br>
</b-container>

</b-overlay>

    <b-modal id="model" centered  scrollable title="ALERT !" :static="true" hide-footer>
      <span class="data" id="modalMsg">  </span>
      <br><br>
        <b-button  style="width:8rem" variant="outline-info" @click="closeModal()">OK</b-button>
    </b-modal>
  </div>

</template>


<script>

import HeaderFixed from '@/components/AS_HeaderFixed.vue'
import HeaderMobile from '@/components/AS_HeaderMobile.vue'
import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
Vue.use(Vuex)
var thColor = '#0288d1';


export default {
  name: '',
  components: {

    'HeaderFixed' : HeaderFixed,
    'HeaderMobile' : HeaderMobile
    //MarqueeText

  },
  data() {
    return {
      consumerNo: '',
      sdCode: '',
      show: false,
    }
  },

  methods: {
    closeModal(){
      this.$bvModal.hide('model')
    },

showSubdiv(x)
{
console.log("inside show");
var distCode=document.getElementById(x).value;
console.log(distCode);
 axios.get("https://www.apdclrms.com/cbs/RestAPI/getSubdiv?districtName="+distCode)
  .then((response) => {

  console.log(response.data);
  document.getElementById("selectSubDiv").innerHTML="";
   var select = document.getElementById("selectSubDiv");
   var option = document.createElement("option");
   option = document.createElement("option");
     option.text = "--Select--";
     option.value = 0;
     select.appendChild(option);

   response.data.forEach(element=>{
        //console.log(item);
        var res=element.split("-")
    option = document.createElement("option");
      option.text = element;
      option.value = res[0];
      select.appendChild(option);
    })

  })
  .catch((e) => {
    parent.show= false;
    parent.$bvModal.show('model');
    document.getElementById("modalMsg").innerHTML="Sorry, Consumer / Bill Not Found";
    console.log("Caught :::::::::::::::", e.message);

})
},
redirectUrl()
		{

			var sV = document.getElementById("selectSubDiv").value;
			var dist = document.getElementById("selectDistrict").value;
			//var selValue = e.options[e.selectedIndex].value ;
			//alert(sV);

			if(sV == '000')
      {
      	alert("Select a Subdivision");
        return
      }
			else
				var url = 'https://www.apdclrms.com/cbs/onlinecrm/newconnectionFinal?subdiv='+sV+'&district='+dist+'&applType=NSC';
			{
				window.open( url, '_blank');
				//window.location.href = "https://apdclrms.com/cbs/onlinecrm/newconnection?subdiv=123";
			}
		}
},
  mounted()
  {

    axios.get('https://www.apdclrms.com/cbs/RestAPI/getAllDistricts')
    .then((response) => {

    console.log(response.data);
    //document.getElementById("selectDistrict").empty();
     var select = document.getElementById("selectDistrict");

    response.data.forEach(function (element, index){
          //console.log(item);
    var  option = document.createElement("option");
        option.text = element;
        option.value = element;
        select.appendChild(option);
      })

    })
    .catch((e) => {
      parent.show= false;
      parent.$bvModal.show('model');
      document.getElementById("modalMsg").innerHTML="Sorry, Try Again";
      console.log("Caught :::::::::::::::", e.message);

  })

  }
}
//background-image: url('../assets/bg.jpg');background-color: #82828226;

</script>

<style scoped="true">
td{
  padding:0.3rem;
}
.label{
font-weight: 600;
}
.data{
  font-weight: 600;
  color: #ff5722         ;
  font-size: 1.5rem;
}
.hideDetails
{
  visibility: hidden;
  opacity: 0;
  transition:visibility 0s, opacity 0.5s linear;
  box-shadow: 2px 2px 10px 2px #bdbdbd;
  padding: 1rem;
}
.showDetails
{
 visibility: visible;
 opacity: 1;
}
hr {
   margin-top: 5px;
   margin-bottom: 5px;
  }
.go:focus{
  box-shadow: none;
}
.headerF{
  display: block;
}
.headerM{
  display: none;
}
.paddingLeft30px{
  padding-left: 30px;
}
.paddingLeftRem{
  padding-left: 1.5rem;
}
@media (max-width: 768px) {
    .headerF{
      display: none;
    }
    .headerM{
      display: block;
    }
    .paddingLeft30px{
      padding-left: 0px;
    }
    .paddingLeftRem{
      padding-left: 0rem;
    }
  }
  @font-face {
    font-family: Assamese_Font;
    src: url("../assets/Assamese_font/KirtanUni.ttf");
  }
  div{
      font-family: arial,Assamese_Font;
  }
</style>
